import ChatWidget from "./components/ChatWidget";
import FacebookConnect from "./components/FacebookConnect";
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

import { QueryProvider } from './providers/query-provider';
import { AuthProvider } from './hooks/useAuth';
import MainLayout from './components/layout/MainLayout';

import LoginPage from './pages/login';
import DelegateCommissionsPage from './pages/DelegateCommissionsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import LoyaltyPage from "./pages/loyalty";
import TicketsPage from "./pages/tickets";
import FAQPage from "./pages/faq";
import LoyaltyPricingPage from "./pages/loyalty-pricing";
import MerchantDashboard from './pages/MerchantDashboard';
import MerchantFulfillmentPage from './pages/MerchantFulfillmentPage';
import AiAssistantPage from './pages/AiAssistantPage';
import CodAccountingPage from './pages/CodAccountingPage';
import CustomerStatementPage from './pages/CustomerStatementPage';
import ScanShipmentsPage from './pages/ScanShipmentsPage';
import BranchTransfersPage from './pages/BranchTransfersPage';
import DelegateDashboard from './pages/DelegateDashboard';
import SmartDashboard from './pages/SmartDashboard';

import { ShipmentsPage } from './pages/shipments';
import ShipmentStatusesPage from './pages/shipment-statuses';
import CreateShipmentPage from './pages/CreateShipmentPage';
import AwaitingApprovalPage from './pages/AwaitingApprovalPage';
import AdminAwaitingApprovalPage from './pages/AdminAwaitingApprovalPage';
import UploadShipmentsPage from './pages/UploadShipmentsPage';
import ShipmentDetailPage from './pages/ShipmentDetailPage';
import EditShipmentPage from './pages/EditShipmentPage';
import ShipmentPrintPage from './pages/ShipmentPrintPage';

import InvoicesPage from './pages/invoices';
import { CreateInvoicePage } from './pages/CreateInvoicePage';

import DrsPage from './pages/drs';
import { DrDetailPage } from './pages/dr-detail';
import { CreateDrPage } from './pages/CreateDrPage';

import PickupsPage from './pages/pickups';
import { CreatePickupPage } from './pages/CreatePickupPage';

import ComplaintsPage from './pages/complaints';
import { CreateComplaintPage } from './pages/CreateComplaintPage';

import RolesPage from './pages/roles';
import { CreateRolePage } from './pages/CreateRolePage';

import UsersPage from './pages/users';
import CreateUserPage from './pages/CreateUserPage';
import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import AboutPage from './pages/AboutPage';
import SupportPage from './pages/SupportPage';
import ContactPage from './pages/ContactPage';
import ContactMessagesPage from './pages/ContactMessagesPage';
import EditUserPage from './pages/EditUserPage';

import BranchesPage from './pages/branches';
import { CreateBranchPage } from './pages/CreateBranchPage';

import CustomersPage from './pages/customers';
import CreateCustomerPage from './pages/CreateCustomerPage';

import DelegatesPage from './pages/delegates';
import CreateDelegatePage from './pages/CreateDelegatePage';

import EmployeesPage from './pages/employees';
import VansPage from './pages/vans';
import ProductsPage from './pages/products';

import AccountingEntriesPage from './pages/accounting-entries';
import AccountsChartPage from './pages/accounts-chart';
import TaxesPage from './pages/taxes';
import BanksPage from './pages/banks';
import ReceiptsPage from './pages/receipts';
import PaymentStatusesPage from './pages/payment-statuses';
import PricingPage from './pages/pricing';

import CitiesPage from './pages/cities';
import ZonesPage from './pages/zones';

import NotificationsPage from './pages/NotificationsPage';
import ReferralsPage from "./pages/referrals";
import RatingsPage from "./pages/ratings";
import CouponsPage from "./pages/coupons";
import EmailPage from "./pages/email";
import TwoFactorPage from "./pages/two-factor";
import AnalyticsPage from "./pages/analytics";
import PaymentsPage from "./pages/payments";
import StorePage from "./pages/store";
import AuditLogsPage from './pages/AuditLogsPage';

import FinancialReportsPage from './pages/FinancialReportsPage';
import ReportsPage from './pages/reports';

import ReturnsPage from './pages/ReturnsPage';
import IntegrationsPage from './pages/IntegrationsPage';

import TemplatesPage from './pages/templates';
import BankAccountsPage from './pages/bank-accounts';
import PriceCategoriesPage from './pages/price-categories';

import OrdersPage from './pages/OrdersPage';
import TrackPage from './pages/TrackPage';
import TrackShipmentPage from './pages/TrackShipmentPage';
import FeedbackPage from "./pages/FeedbackPage";

import GPSTrackingPage from './pages/GPSTrackingPage';
import DelegateTrackingPage from './pages/DelegateTrackingPage';

import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import WhatsAppPage from './pages/WhatsAppPage';
import DelegateDashboardPage from "./pages/delegate-dashboard";
import DriverOpportunitiesPage from './pages/DriverOpportunitiesPage';
import CEODashboardPage from "./pages/ceo-dashboard";
import WhatsAppBotPage from './pages/WhatsAppBotPage';
import WarehousesPage from './pages/WarehousesPage';
import VanStocksPage from './pages/VanStocksPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/track" element={<TrackPage />} />
          <Route path="/track/:trackingNumber" element={<TrackShipmentPage />} />
      <Route path="/feedback/:trackingNumber" element={<FeedbackPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/" element={<LandingPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/contact-messages" element={<ContactMessagesPage />} />
          <Route path="/dashboard" element={<SmartDashboard />} />
          <Route path="/merchant/dashboard" element={<MerchantDashboard />} />
          <Route path="/merchant/fulfillment" element={<MerchantFulfillmentPage />} />
          <Route path="/ai-assistant" element={<AiAssistantPage />} />
          <Route path="/accounting/cod" element={<CodAccountingPage />} />
          <Route path="/accounting/statement" element={<CustomerStatementPage />} />
          <Route path="/shipments/scan" element={<ScanShipmentsPage />} />
          <Route path="/branch-transfers" element={<BranchTransfersPage />} />
          <Route path="/delegate/dashboard" element={<DelegateDashboard />} />
          <Route path="/driver/opportunities" element={<DriverOpportunitiesPage />} />

          <Route path="/shipments" element={<ShipmentsPage />} />
          <Route path="/delegate/shipments" element={<ShipmentsPage />} />
          <Route path="/shipments/new" element={<CreateShipmentPage />} />
          <Route path="/shipments/create" element={<CreateShipmentPage />} />
          <Route path="/shipments/:id" element={<ShipmentDetailPage />} />
          <Route path="/shipments/:id/edit" element={<EditShipmentPage />} />
          <Route path="/shipments/:id/print" element={<ShipmentPrintPage />} />
          <Route path="/shipment-statuses" element={<ShipmentStatusesPage />} />

          <Route path="/gps-tracking" element={<GPSTrackingPage />} />
          <Route path="/delegate/tracking" element={<DelegateTrackingPage />} />

          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/invoices/new" element={<CreateInvoicePage />} />

          <Route path="/drs" element={<DrsPage />} />
          <Route path="/drs/:id" element={<DrDetailPage />} />
          <Route path="/drs/new" element={<CreateDrPage />} />

          <Route path="/pickups" element={<PickupsPage />} />
          <Route path="/pickups/new" element={<CreatePickupPage />} />

          <Route path="/complaints" element={<ComplaintsPage />} />
          <Route path="/complaints/new" element={<CreateComplaintPage />} />

          <Route path="/roles" element={<RolesPage />} />
          <Route path="/roles/new" element={<CreateRolePage />} />
          <Route path="/roles/:id" element={<CreateRolePage />} />

          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/new" element={<CreateUserPage />} />
          <Route path="/users/edit/:id" element={<EditUserPage />} />

          <Route path="/branches" element={<BranchesPage />} />
          <Route path="/branches/new" element={<CreateBranchPage />} />

          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/new" element={<CreateCustomerPage />} />

          <Route path="/delegates" element={<DelegatesPage />} />
          <Route path="/delegates/new" element={<CreateDelegatePage />} />

          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/vans" element={<VansPage />} />
          <Route path="/products" element={<ProductsPage />} />

          <Route path="/accounting-entries" element={<AccountingEntriesPage />} />
          <Route path="/accounts-chart" element={<AccountsChartPage />} />
          <Route path="/taxes" element={<TaxesPage />} />
          <Route path="/banks" element={<BanksPage />} />
          <Route path="/receipts" element={<ReceiptsPage />} />
          <Route path="/payment-statuses" element={<PaymentStatusesPage />} />

          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/zones" element={<ZonesPage />} />
          <Route path="/delegate-commissions" element={<DelegateCommissionsPage />} />

          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/notifications-page" element={<NotificationsPage />} />

          <Route path="/audit-logs" element={<AuditLogsPage />} />

          <Route path="/financial-reports" element={<FinancialReportsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports-advanced" element={<ReportsPage />} />

          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />

          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/bank-accounts" element={<BankAccountsPage />} />
          <Route path="/price-categories" element={<PriceCategoriesPage />} />

          <Route path="/orders" element={<OrdersPage />} />

          <Route path="/loyalty" element={<LoyaltyPage />} />
          <Route path="/referrals" element={<ReferralsPage />} />
          <Route path="/ratings" element={<RatingsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/two-factor" element={<TwoFactorPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/whatsapp" element={<WhatsAppPage />} />
          <Route path="/delegate-dashboard" element={<DelegateDashboardPage />} />
          <Route path="/ceo-dashboard" element={<CEODashboardPage />} />
          <Route path="/loyalty-pricing" element={<LoyaltyPricingPage />} />

          <Route path="/van-stocks" element={<VanStocksPage />} />
          <Route path="/warehouses" element={<WarehousesPage />} />
          <Route path="/whatsapp-bot" element={<WhatsAppBotPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />

          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/shipments/upload" element={<UploadShipmentsPage />} />
          <Route path="/shipments/pending" element={<AwaitingApprovalPage />} />
          <Route path="/shipments/awaiting-approval" element={<AdminAwaitingApprovalPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <QueryProvider>
        <AppRoutes />
        <ChatWidget />
        <FacebookConnect />
      </QueryProvider>
    </AuthProvider>
  );
}
